// extracted by mini-css-extract-plugin
export default {"secondHeadline":"style_secondHeadline__Ysg+3","btn":"style_btn__7vRbp","section":"style_section__W5hLj","image":"style_image__r+IEM"};